module.exports = __webpack_public_path__ + "static/media/bm_banner.e18926e1.png";